module.exports = __webpack_public_path__ + "static/img/logo.a8db9303.jpg";